import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Unsorted = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Unsorted" {...props}>
    <path d="M17.2004 3C17.7524 3.00027 18.2004 3.44789 18.2004 4V17.5859L21.2931 14.4932C21.6837 14.1027 22.3167 14.1027 22.7072 14.4932C23.0975 14.8837 23.0976 15.5168 22.7072 15.9072L17.2004 21.4141L11.6935 15.9072C11.303 15.5167 11.303 14.8837 11.6935 14.4932C12.0841 14.1028 12.7171 14.1027 13.1076 14.4932L16.2004 17.5859V4C16.2004 3.44772 16.6481 3.00001 17.2004 3Z" fill="#000" /><path d="M12.3068 8.09277C12.6972 8.48327 12.6972 9.11633 12.3068 9.50684C11.9163 9.89723 11.2833 9.89722 10.8928 9.50684L7.79998 6.41406V20C7.79998 20.5522 7.35217 20.9999 6.79998 21C6.24784 20.9998 5.79999 20.5522 5.79998 20V6.41406L2.70721 9.50684C2.31672 9.89733 1.68368 9.89726 1.29315 9.50684C0.902722 9.11631 0.90266 8.48327 1.29315 8.09277L6.79998 2.58594L12.3068 8.09277Z" fill="#000" />
  </StyledIcon>
));

Unsorted.displayName = 'Unsorted';

export { Unsorted };
